module.exports = __webpack_public_path__ + "static/fonts/NanumGothic-Bold.fe20860.woff";